import { URI_REPORT } from '@/config/config';

export default async ({ rootState }, { date }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(
    `${URI_REPORT}reports/settled-credits?date=${date}`,
    opts,
  );
  const jsonResult = await response.json();
  if (response.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult.data;
};
